const SET_SEO_CONTENT = 'SET_SEO_CONTENT';

const setSeoContent = ({ categories, cities, searches }) => ({
  type: SET_SEO_CONTENT,
  payload: {
    categories,
    cities,
    searches
  }
});

export {
  SET_SEO_CONTENT,
  setSeoContent
};
